/**
 * emailRegex: Validates an email with alphanumeric, periods, plus, hyphen, underscores,
 * and a domain with 2+ characters after a dot.
 */
export const emailRegex =
  /^[A-Za-z0-9](?:[A-Za-z0-9._%+-]*[A-Za-z0-9])?@[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?(?:\.[A-Za-z]{2,})+$/;


/**
 * passwordRegex: Validates passwords with at least 8 characters, including an uppercase
 * letter, a digit, and a special character.
 */
export const passwordRegex =
  /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

/**
 * regex for checking non-numeric characters
 */
export const nonDigitRegex = /\D/g;
export const decimalRegex = /^\d*\.?\d*$/;

/**
 * regex for checking only alphabetic characters with parentheses
 */
export const onlyAlphaWithParensRegex = /^[a-zA-Z.() ]+$/;
export const onlyAlphaRegex = /^[a-zA-Z ]+$/;
export const alphaNumericSpaceRegex = /^[A-Za-z0-9 ]+$/;
export const alphaNumericWithParensPeriodRegex = /^[A-Za-z0-9.() \n]+$/;
export const alphaNumericWithPeriodRegex = /^[A-Za-z0-9. \n]+$/;
export const alphaNumericWithParensPeriodCommaRegex = /^[A-Za-z0-9.,() \n]+$/;
export const specialistDesignationRegex = /^[A-Za-z ,.\/&()-]+$/;
export const specialistEduccationRegex = /^[A-Za-z ,./&()'-]+$/;
export const licenseNumber = /^[A-Za-z0-9\/\- ]+$/;

export const professionalExperienceAndQualificationRegex = /^[A-Za-z0-9 ,./&()':\-]+$/;
export const awardsAndAchievementsRegex = /^[A-Za-z0-9 ,.&()':/\-]+$/;
export const areasOfExpertiseRegex = /^[A-Za-z0-9 ,&()\/\-]+$/;;

//phone regex
export const indianPhoneRegex = /^(?:\+91|91)?[7896]\d{9}$/;
export const internationalPhoneRegex = /^\+?[1-9]\d{7,14}$/;

//name regex
export const nameRegex = /^[A-Za-z]+(?: [A-Za-z]+)*$/;

export const domainRegex = /(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/;


// file regex
export const imageFileRegex = /(\.png|\.jpe?g|\.gif|\.webp)$/i;
export const pdfFileRegex = /\.pdf$/i;


// filter regex
export const chargeFilterLabelRegex = /^[0-9<=>-]+$/;
export const ratingFilterLabelRegex = /^[0-9.]+$/;
export const experienceFilterLabelRegex = /^[0-9-]+$/;

// hospital admin regex
export const hospitalNameRegex = /^[A-Za-z][A-Za-z-–. &',()+@#/0-9]*$/;